import { z } from "zod";

import { zDateTimeString } from "../../dateTypes.js";
import { zOutputContentId } from "../../zod/ZodIdTypeBrands.js";

/**
 * An output content as it appears inside another event's payload, before it has
 * been associated with an output.
 */
export const zUnattachedOutputContent = z.object({
  id: zOutputContentId,
  createdDate: zDateTimeString,
  mimeType: z.string(),
});
